module.exports = __webpack_public_path__ + "ac0c825e76851b740da5ce261793a43e.svg";